<div class="flex flex-middle">
    <action class="w-12 button"
            [class.left]="!modal()"
            [class.is-disabled]="isOutOfStock"
            cy-basketAddButton
            [clickEvent]="'add-to-basket.clicked'"
            [status]="status"
            (click)="submit()">
        @if (isOutOfStock) {
        <span class="w-12 flex flex-middle flex-justify-center gap-12px p1">
            <i class="icon-email-24"
               aria-hidden="true"></i>
            {{'Out of stock - notify me' | translate}}
        </span>
        } @else {
        @if (!status.busy) {
        {{buttonCopy}}
        } @else {
        {{'Adding...' | translate}}
        }
        }
    </action>
    @if (hasPalette) {
    <button class="_palette"
            uiButton
            (click)="handlePaletteClick()">
        <i></i>
    </button>
    }
</div>
<result class="block s1"
        [class]="panel() ? 'm-t-2' : 'p-t-2-m p-t-2-s p-r-4-m p-r-4-s p-b-2-m p-b-2-s p-l-4-m p-l-4-s'"
        [status]="status" />
@if (warning) {
<p class="s1 col-2"
   [class]="panel() ? 'm-t-2' : 'p-t-2-m p-t-2-s p-r-4-m p-r-4-s p-b-2-m p-b-2-s p-l-4-m p-l-4-s'">
    {{warning}}
</p>
}